export default "__VITE_ASSET__BAuvwJQi__"